import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import {  BaseURL, uniqueToken, OcppSocketURL } from '../../api/DataApis';
import request from '../../Apis/request';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

import { Link } from 'react-router-dom';
import Loader from '../Chargers/Loader';
import ReactPaginate from 'react-paginate'; 
import Select from 'react-select';


const OcppLogs = () => {
  document.title = "OCPP || OCPP-Logs";
  const [OCPPData, setOCPPData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ChargerData, setChargerData] = useState([]);
  const [selectedchargerEmi, setSelectedChargerEmi] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [transactionmodalIsOpen, settransactionModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [Message, setMessage] = useState([]);
  const [MessageType, setMessageType] = useState([]);
  const [connectorIDValue, setConnectorIDValue] = useState([]);
  const [IDtag, setIDTag] = useState('');
  const [transactionID, settransactionID] = useState('');
  const [selectedLimit, setSelectedLimit] = useState("");
  const [modalAamountContent, setModalAmountContent] = useState('');
  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [Users, setUsers] = useState([]);
  const [selectedUserID, setSelectedUserID] = useState('');
  const [selectedConnectorID, setSelectedConnectorID] = useState('');
  const [selectedchargerID, setSelectedChargerID] = useState('');
  const [selectedAmount, setSelectedAmount] = useState('');
  const [selectedUserMobile, setSelectedUserMobile] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [applyFilters, setApplyFilters] = useState(false);
  const [TotalCount, setTotalCount] = useState(null);
  const [connectorListing, setconnectorListing] = useState([]);
  const [ master_connector_id, setMasterConnectorId ] = useState("");
  const [errors, setErrors] = useState({});
  const [Limit, setLimit] = useState({});
  const [page, setPage] = useState(1); 
  const [pageCount, setPageCount] = useState(0); 
  const [walletAmount, setWalletAmount] = useState("");

  useEffect(() => {
    // Get today's date
    const today = new Date().toISOString().split("T")[0]; // Formats the date as "YYYY-MM-DD"

    // Set today's date as the default value for both fromDate and ToDate
    setFromDate(today);
    setToDate(today);
  }, []);

  const handleReset =()=> {
    setPage(1);
    };
console.log("fromDate...", fromDate);
console.log("toDate",ToDate );

    const handleResett = (event) => {
      event.preventDefault()
     navigate(`/ocpp/ocpp-logs`);
      }


  const chargerOptions = ChargerData?.map((item) => ({
    value: `${item?.imei_number}@${item?._id}`, // Value combines IMEI and ID
    label: item?.imei_number, // Display the IMEI number
  }));

  const UserOptons = Users?.map(user => ({
    value: user._id,
    label: `${user.name} (${user.mobile})`,
  mobile: user?.mobile,
  wallet_amount: user?.wallet_amount
  }));
  
  let navigate = useNavigate();
  const generateRandomNumber = () => {
    return Math.floor(10000000 + Math.random() * 90000000); // Generates a number between 10000 and 99999
  };

  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  const handlefromDate = (e) => {
    setFromDate(e.target.value);
  }
  const handleToDate = (e) => {
    setToDate(e.target.value);
  }
  const handleMessageTypeChange = (e) => {
  setMessageType(e.target.value);
  };
  // const fetchFilteredData = async () => {
  //   const apiEndpoint = `${BaseURL}/occpLog?request_3=${MessageType}&from_date=${fromDate.toString()}&to_date=${ToDate.toString()}&limit=${selectedLimit}`;
  //   //http://34.135.232.219:5000/api/admin/occpLog?request_3=StatusNotification&from_date=2024-09-10&to_date=2024-09-20

  
  //   try {
  //     const response = await axios.get(apiEndpoint, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${uniqueToken}`,
  //       },
  //     });
  //     console.log('Filtered data:', response.data);
  //     setUsers(response.data.data || []);
      
  //     // Process the response data as needed
  //   } catch (error) {
  //     console.error('Error fetching filtered data:', error);
  //   }
  // };



console.log("ChargerData", ChargerData);
const handleUserid = (selectedOption) => {
  if (selectedOption) {
    console.log("-----------------------", selectedOption?.wallet_amount)
    const { value: selectedUserID, mobile: selectedMobile, wallet_amount: walletAmount } = selectedOption;

    setSelectedUserID(selectedUserID); // Store the user ID
    setSelectedUserMobile(selectedMobile); // Store the mobile number
    setWalletAmount(walletAmount); // Store wallet amount

    console.log('Selected User ID:', selectedUserID);
    console.log('Selected User Mobile:', selectedMobile);
    console.log('Wallet Amount:', walletAmount);
  } else {
    // Clear selections if no option is selected
    setSelectedUserID(null);
    setSelectedUserMobile(null);
    setWalletAmount(null);
  }
};

const handleAmount = (e)=> {
  setSelectedAmount(e.target.value);
}
const handleConnectorID = (e)=> {
  
  setMasterConnectorId(e.target.value);
  const connectorId = e.target.selectedOptions[0].getAttribute('connectorId');
  console.log("e.target.value", e.target.value, "connectorId", connectorId );
  setSelectedConnectorID(connectorId);
}
//handleUserid, handleAmount, handleConnectorID
const handleChargerEmiChange = (selectedOption) => {
  if (selectedOption) {
    const [imei, id] = selectedOption.value.split("@");
    console.log("Selected IMEI and ID:", imei, id);
    setSelectedChargerEmi(imei);
    setSelectedChargerID(id);
  } else {
    setSelectedChargerEmi(null);
    setSelectedChargerID(null);
  }
};
  const handleFetchingChange = () => {
    fetchOcppData();
  };
  const handleTransactionIDChange = (e) => {
    settransactionID(e.target.value);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

 
  const handleConnectorIDChange = (e) => {
    setConnectorIDValue(e.target.value);
  };

  const handleIDTagChange = (e) => {
    setIDTag(e.target.value);
  }
console.log("selectedchargerID", selectedchargerID);
  const fetchChargers = async () => {
    setLoading(true);
    const apiEndpoint = `${BaseURL}/chargers?master_charger_type=ocpp-0`;

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      }); 
      if(response?.data?.data?.status == 200) {
      setChargerData(response.data.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching ChargerData:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChargers();
  }, []);
  // useEffect(() => {
  //   fetchFilteredData();
  // }, []);

  const fetchOcppData = async (applyFilters = false, messageType = null, FromDate = null, toDate = null) => {
    setLoading(true);

    const queryParams = [];

    // Include `chargerEmi` filter if it's selected
    if (selectedchargerEmi) {
        queryParams.push(`charger_emi=${selectedchargerEmi}`);

        // Also include `messageType` if it's provided when `chargerEmi` is selected
        const finalMessageType = messageType || MessageType;
        if (finalMessageType) {
            queryParams.push(`request_3=${finalMessageType}`);
        }
    }

    // If `applyFilters` is true, add any additional selected filters to the query
    if (applyFilters) {
        const finalMessageType = messageType || MessageType;
        if (finalMessageType && !queryParams.includes(`request_3=${finalMessageType}`)) {
            queryParams.push(`request_3=${finalMessageType}`);
        }
    }

    // Use the passed `FromDate` and `toDate` or fallback to state values `fromDate` and `ToDate`
    const finalFromDate = FromDate || fromDate;  // If FromDate is passed, use it, otherwise use the state `fromDate`
    const finalToDate = toDate || ToDate;  // If toDate is passed, use it, otherwise use the state `ToDate`

    console.log("Final FromDate:", finalFromDate);
    console.log("Final ToDate:", finalToDate);

    // If `fromDate` or `ToDate` are not provided, fallback to today's date
    if (!finalFromDate) {
        const today = new Date().toISOString().split('T')[0];  // Format as YYYY-MM-DD
        queryParams.push(`from_date=${today} 00:00:00`);  // Default from date to today at 00:00:00
    } else {
        queryParams.push(`from_date=${finalFromDate} 00:00:00`);  // Use the passed or state `fromDate`
    }

    if (!finalToDate) {
        const today = new Date().toISOString().split('T')[0];  // Format as YYYY-MM-DD
        queryParams.push(`to_date=${today} 23:59:59`);  // Default to date to today at 23:59:59
    } else {
        queryParams.push(`to_date=${finalToDate} 23:59:59`);  // Use the passed or state `ToDate`
    }

    // Include `limit` filter if selected
    if (selectedLimit) {
        queryParams.push(`limit=${selectedLimit}`);
    }

    // Create the query string
    const queryString = queryParams.length > 0 ? `&${queryParams.join('&')}` : '';

    try {
        const apiEndpoint = `${BaseURL}/occpLog/?page=${page}${queryString}`;
        const response = await axios.get(apiEndpoint, {
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });

        console.log('Fetched data:', response?.data);

        if(response?.data?.status === 200) {
            const data = response.data?.data || [];
            const totalCount = response.data?.totalCount || 0;
            const limits = response?.data?.limit || 0;

            setOCPPData(data);
            setPageCount(Math.ceil(totalCount / limits || 0));
            setTotalCount(totalCount);
            setLimit(limits);
        }
        setLoading(false);
    } catch (error) {
        console.error("Error fetching OCPP data:", error);
    } finally {
        setLoading(false);
    }
};





  
  
  
  // Handle filter button click (Case 3)
  const handleFilterClick = () => {
    setPage(1);
    // Trigger fetch with `applyFilters` set to true and pass available filters
    const applyFilters = true;
  
    // Call the fetch function with the selected filters
    fetchOcppData(
      applyFilters,
      MessageType || null,  // Pass the selected messageType or null if not selected
      fromDate || null,     // Pass the selected fromDate or null if not selected
      ToDate || null,
      selectedLimit || null      // Pass the selected toDate or null if not selected
    );
  };
  useEffect(() => {
    if (selectedchargerEmi) {
      fetchOcppData(page); // Fetch data without hitting a button when selectedchargerEmi changes
    } 
    else {
      fetchOcppData();
    }
  }, [selectedchargerEmi, page]);// Empty dependency array ensures it runs once on component mount
  
   // Trigger whenever `selectedchargerEmi` changes
  
  

// Your filter button should call handleFilterClick
// <button onClick={handleFilterClick}>Apply Filters</button>
// Update dependencies as needed
  
// 
  const openModal = (content) => {
    setModalContent(content);
    setModalIsOpen(true);
  };
  console.log("modalcontent", modalContent);
  const closeModal = () => {
    setModalIsOpen(false);
    setModalContent('');
  };

  const openAmountModal = () => settransactionModalIsOpen(true);

  // Function to handle closing the modal
  const closeAmountModal = () => settransactionModalIsOpen(false);

  // Function to handle form submission
  const handleSubmition = () => {
    console.log('Input 1:', input1);
    console.log('Input 2:', input2);
    // Perform any other action on form submission
    closeAmountModal();
  };

  const handleAmountSubmit = async () => {
    const url = `${BaseURL}/user/required-amount/${selectedUserID}`;
  
    try {
      const response = await axios.post(
        url,
        {
          "charger_id": selectedchargerID,
          "amount": selectedAmount,
          "master_connector_id": master_connector_id,
        },
        {
          headers: {
            "Content-Type": "Application/json",
            Authorization: `Bearer ${uniqueToken}`,
          }
        }
      );
  
      if (response?.data?.statusCode === 200) {

        Swal.fire({
          icon: "success",
          title: "success",
          text: response?.data?.message || "An error occurred. Please try again.",
        });    
        // Success logic, call next API after closing the modal
        console.log("Success:", response?.data?.message);
        setWalletAmount(''); 
        closeAmountModal();
  fetchOcppData();
        // Trigger the next API function
        //handleTriggersFunction(selectedConnectorID);
      } else {
        // Handle validation or non-success errors with Swal
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.data?.message || "An error occurred. Please try again.",
        });
        // closeAmountModal();
      }
    } catch (error) {
      // Catch any other errors (like network issues, etc.)
      const errorMessage = error?.response?.data?.message || "Something went wrong!";
  
      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: errorMessage,
      });
  
      // closeAmountModal();
    }
  };
  
  
  
  
  const handleTriggersFunction = (connectorId) => {
    console.log("selectedUserMobilesssss", selectedUserMobile);
    console.log("connectorIdddddd", connectorId)
    if (!selectedchargerEmi) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a charger.",
      });
      return;
    }
    
    const randomNumber = generateRandomNumber();
    const socketUrl = `${OcppSocketURL}/ocpp/${selectedchargerEmi}`;
    const socket = new WebSocket(socketUrl);
    
    socket.onopen = () => {
      console.log('WebSocket connection opened.');
      
      const request = [2, randomNumber.toString(), "RemoteStartTransaction", {
        "connectorId": connectorId,  // Pass connectorId from the previous response
        "idTag": selectedUserMobile,  // Assuming you have selectedUserMobile for mobile number
      }];
      
      // Send message
      socket.send(JSON.stringify(request));
    };
  
    // Handle incoming messages
    socket.onmessage = (event) => {
      const response = JSON.parse(event.data);
      console.log('Received response:', response);
  
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: response.message,
        showConfirmButton: false,
        timer: 1500,
      });
      fetchOcppData();
      socket.close();  // Close connection after receiving the response
    };
  
    // Handle errors
    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while triggering the message",
      });
    };
  
    socket.onclose = (event) => {
      if (event.wasClean) {
        console.log(`Connection closed cleanly, code=${event.code}, reason=${event.reason}`);
      } else {
        console.error("Connection died");
      }
    };
  };
  


  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    if (!selectedchargerEmi) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a charger.",
      });
      return false;
    }
    if (modalContent !== "RemoteStopTransaction" && !selectedConnectorID) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a connector.",
      });
      return false; 
    }
    console.log("Submitting form data", { Message, connectorIDValue });

    // Call handleTriggerFunction to hit the API when form is submitted
    await handleTriggerFunction();
    fetchOcppData();

    // Close the modal after successful form submission
    closeModal();
  };

  const handleTriggerFunction = () => {


    const randomNumber = generateRandomNumber();
    const socketUrl = `${OcppSocketURL}/ocpp/${selectedchargerEmi}`;
    const socket = new WebSocket(socketUrl);
  
    // Open connection
    socket.onopen = () => {
      console.log('WebSocket connection opened.');
  
      let request;
      if (modalContent === "TriggerMessage") {
        request = [2, randomNumber.toString(), modalContent, {
          "requestedMessage": Message, 
          "connectorId": parseInt(selectedConnectorID)
        }];
      } else if (modalContent === "RemoteStartTransaction") {
        request = [2, randomNumber.toString(), modalContent, {
          "connectorId": parseInt(selectedConnectorID), 
          "idTag": IDtag
        }];
      } else if (modalContent === "RemoteStopTransaction") {
        request = [2, randomNumber.toString(), modalContent, {
          "transactionId": parseInt(transactionID)
        }];
      } else {
        request = [2, randomNumber.toString(), "ChangeAvailability", {
          "type": Message
        }];
      }
  
      // Send message
      socket.send(JSON.stringify(request));
    };
  
    // Handle incoming messages
    socket.onmessage = (event) => {
      const response = JSON.parse(event.data);
      console.log('Received response:', response);
  
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: response.message,
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        // Clear the states after success
        setSelectedConnectorID('');
       
      });
  
      // Close the socket after receiving the response
      socket.close();
      fetchOcppData();
    };
  
    // Handle errors
    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while triggering the message",
      });
    };
  
    // Handle connection close
    socket.onclose = (event) => {
      if (event.wasClean) {
        console.log(`Connection closed cleanly, code=${event.code}, reason=${event.reason}`);
      } else {
        console.error("Connection died");
      }
    };
  };
  
  const handleExport = async () => {
    // If either `selectedchargerEmi` or `selectedLimit` is selected, proceed
    if (selectedchargerEmi || selectedLimit) {
      let apiUrll = `${BaseURL}/occpLog/download-excel?`;
  
      // Case 1: Append `selectedchargerEmi` if it is selected
      if (selectedchargerEmi) {
        apiUrll += `charger_emi=${selectedchargerEmi}&`;
      }
  
      // Case 2: Append `selectedLimit` if it is selected
      if (selectedLimit) {
        apiUrll += `limit=${selectedLimit}&`;
      }
  
      // Append date filters if they exist
      if (fromDate) {
        apiUrll += `from_date=${fromDate.toString()}&`;
      }
  
      if (ToDate) {
        apiUrll += `to_date=${ToDate.toString()}&`;
      }
  
      // Remove the trailing "&" if it exists
      apiUrll = apiUrll.endsWith("&") ? apiUrll.slice(0, -1) : apiUrll;
  
      try {
        const response = await fetch(apiUrll, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
  
        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `data_${selectedLimit ? `limit_${selectedLimit}` : `emi_${selectedchargerEmi}`}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } else {
          alert("Failed to export data. Please try again.");
        }
      } catch (error) {
        console.error("Error exporting data:", error);
        alert("An error occurred while exporting data.");
      }
    } else {
      // Case 3: Neither `selectedchargerEmi` nor `selectedLimit` is selected
      alert("Please select a limit or charger EMI before exporting.");
    }
  };

  const fetchUsers = async () => {
    setLoading(true);
    
    const apiUrl = `${BaseURL}/user/get-all`;

    try {
        const response = await axios.get(apiUrl, {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });
        console.log("response", response);
        setUsers(response.data.data || []);
      
    } catch (error) {
        console.error("Error fetching users:", error);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchConnectors = async () => {
    setLoading(true);
    
    const apiUrl = `${BaseURL}/master/dc-0`;

    try {
        const response = await axios.get(apiUrl, {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });
        console.log("response", response);
        setconnectorListing(response.data.data || []);
      
    } catch (error) {
        console.error("Error fetching users:", error);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchConnectors();
  }, []);

const handleRefetch = () => {
  fetchOcppData();
}

 console.log("OCPPData", OCPPData);
 console.log("totalCount", TotalCount);
 console.log("Limit", Limit);

  return (
    <div className='container-fluid' style={{ minHeight: '100vh', padding: '0px', margin: '0px' }}>
      <div className='row' style={{ height: '100%' }}>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-start align-items-center">
    <h4 className="mb-0 mr-2">OCPP Logs({TotalCount ? TotalCount : "Loading..."})</h4> {/* Add mb-0 to remove bottom margin */}
    
  </div>

  <div className="card-header pb-0">
  <div className="d-flex justify-content-between mb-2"> {/* Changed justify-content */}
    <div className="button-group d-flex gap-2" style={{ top: "20px" }}>
      <div style={{ display: "inline-flex", alignItems: "center" }}>
        <select
          className="form-control"
          onChange={handleMessageTypeChange}
          style={{
            height: '34px',
            marginRight: '10px', // Removed marginLeft
            width: '160px', // Adjusted to fit better
          }}
        >
          <option value="">Select Trigger</option>
          <option value="BootNotification">Boot Notification</option>
          <option value="DiagnosticsStatusNotification">Diagnostics Status Notification</option>
          <option value="FirmwareStatusNotification">Firmware Status Notification</option>
          <option value="Heartbeat">Heartbeat</option>
          <option value="MeterValues">Meter Values</option>
          <option value="StatusNotification">Status Notification</option>
          <option value="RemoteStartTransaction">Remote Start Transaction</option>
          <option value="RemoteStopTransaction">Remote Stop Transaction</option>
          <option value="StartTransaction">Start Transaction</option>
          <option value="StopTransaction">Stop Transaction</option>
          <option value="Authorize">Authorize</option>
        </select>

    <input
  type="text"
  value={fromDate}
  className="form-control select2 select2-offscreen"
  onFocus={(e) => (e.target.type = "date")}
  onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
  placeholder="From Date"
  onChange={handlefromDate}
  style={{ height: '34px', marginRight: '10px', width: '160px' }} // Adjusted width for dates
/>

<input
  type="text"
  value={ToDate}
  className="form-control select2 select2-offscreen"
  onFocus={(e) => (e.target.type = "date")}
  onBlur={(e) => (e.target.type = e.target.value ? "date" : "text")}
  placeholder="To Date"
  onChange={handleToDate}
  style={{ height: '38px', marginRight: '10px', width: '160px' }} // Adjusted width for dates
/>


        <input
          type="button"
          className="btn btn-success"
          style={{ marginRight: '10px', height: '34px',  cursor: "pointer", // Change cursor to pointer on hover
            transition: "background 0.3s, transform 0.2s",  }} // Adjust height
          value="Filter"
          onClick={handleFilterClick}
        />

<button
          className="btn btn-success"
          style={{ marginRight: '10px', height: '34px',  cursor: "pointer", // Change cursor to pointer on hover
            transition: "background 0.3s, transform 0.2s",  }} // Adjust height
          
          onClick={handleResett}
        >Reset
          </button>

        <select
          value={selectedLimit}
          onChange={(e) => setSelectedLimit(e.target.value)}
            className="form-control"
          style={{
            height: "34px", // Adjusted height to match others
           
            marginRight: "10px",
            width: '130px', // Adjusted to fit better
          }}
        >
          <option value="">Select Limit</option>
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="1000">1000</option>
          <option value="2000">2000</option>
        </select>

        <button
  className="drop-marg12 btn btn-success"
  style={{
    height: "34px", // Maintain height
    width: "100px", // Increased width for better appearance
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "10px",
    padding: "0 10px", // Added horizontal padding for more space around text
    fontWeight: "bold", // Make the font bold
    fontSize: "14px", // Adjust font size if necessary
    letterSpacing: "0.5px", // Add letter spacing
    cursor: "pointer", // Change cursor to pointer on hover
    transition: "background 0.3s, transform 0.2s", // Smooth transition effects
  }}
  onClick={handleExport}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#218838"; // Darker shade on hover
    e.target.style.transform = "scale(1.05)"; // Slightly enlarge on hover
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = ""; // Reset to Bootstrap's default success color
    e.target.style.transform = "scale(1)"; // Reset scale
  }}
>
  Export
</button>
      </div>
    </div>
  </div>

  <hr style={{ marginTop: "0px" }} />
</div>

                <div className="row" style={{ display: 'flex', alignItems: 'flex-start' }}>
                {selectedchargerEmi && (
                  <div className="col-md-3">
                    <div className="commands-container p-3" style={{
                      borderRadius: "5px",
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      flexShrink: 0,
                      border: '1px solid #000000'
                    }}>
                      <h5 className="text-white">Commands</h5>
                      <button className="btn btn-primary btn-block mb-2" onClick={() => openModal('TriggerMessage')}>
                        TRIGGER MESSAGE
                      </button>
                      <button className="btn btn-primary btn-block mb-2" style={{ padding: '20px', lineHeight: '1.5' }} onClick={() => openModal('RemoteStartTransaction')}>
                        REMOTE START <br />TRANSACTION
                      </button>
                      <button className="btn btn-primary btn-block mb-2" style={{ padding: '20px', lineHeight: '1.5' }} onClick={() => openModal('RemoteStopTransaction')}>
                        REMOTE STOP<br /> TRANSACTION
                      </button>
                      <button className="btn btn-primary btn-block mb-2" onClick={() => openModal('ChangeAvailability')}>
                        RESET
                      </button>
                    </div>
                  </div>
                )}

                <div className={selectedchargerEmi ? "col-md-9" : "col-md-12"}>
                <div className="card-body" style={{ paddingTop: 0 }}>
  <div className="form-container" style={{ display: 'flex', alignItems: 'center' }}>
       <Select
  options={chargerOptions} // Pass the options array
  onChange={handleChargerEmiChange} // Handle selection
  placeholder="Select Charger"
  isClearable // Allow clearing the selection
  className="form-control"
  styles={{
    control: (base) => ({
      ...base,
      height: '34px',
      width: '180px',
      marginRight: '10px',
    }),
  }}
/>

    {selectedchargerEmi && (
      <input
        type="button"
        className="btn btn-success"
        value="Charging Request"
        onClick={openAmountModal}
        style={{ height: '38px', marginRight: '10px' }} // Ensures the button is the same height as the select
      />
    )}
  </div>

  {loading ? (
  <Loader />
) : (
  <>
<div className="table-responsive">
  {loading ? (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
      <Loader />
    </div>
  ) : (
    <>
      {Array.isArray(OCPPData) && OCPPData.length === 0 ? ( // Check if OCPPData exists and is non-empty
        <>
        <h5>No data Found</h5>
        </> ) : (
          <>
          <table className="display dataTable" id="advance-1">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Charger EMI</th>
                <th>Charge Point to Central System</th>
                <th>Central System to Charge Point</th>
                <th>Created Date</th>
              </tr>
            </thead>
            <tbody>
              {OCPPData.map((ocpp, index) => (
                <tr key={index}>
                  <td>{(page - 1) * Limit + index + 1}</td>
                  <td>{ocpp?.charger_emi}</td>
                  <td><pre>{JSON.stringify(ocpp.request, null, 2)}</pre></td>
                  <td><pre>{JSON.stringify(ocpp.response, null, 2)}</pre></td>
                  <td>{ocpp?.createdAt}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Component */}
         
        </>
      ) }
    </>
  )}
</div>
<div className="pagination-container mt-4">
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              forcePage={page - 1}
            />
          </div>

  </>
)}

</div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Command Modal"
        ariaHideApp={false}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '50%'
          },
        }}
      >
        <h2>{modalContent}</h2>
        <form onSubmit={handleSubmit}>
          {modalContent === 'TriggerMessage' && (
            <>
              <div className="form-group">
                <label>Message</label>
                <select className="form-control" onChange={handleMessageChange} id="input1">
      <option value="0">Select Message</option>
      <option value="BootNotification">BootNotification</option>
      <option value="DiagnosticsStatusNotification">DiagnosticsStatusNotification</option>
      <option value="FirmwareStatusNotification">FirmwareStatusNotification</option>
      <option value="Heartbeat">Heartbeat</option>
      <option value="MeterValues">MeterValues</option>
      <option value="StatusNotification">StatusNotification</option>
    </select>              </div>
              <div className="form-group">
                <label>Connector ID</label>
                <select className="form-control"  onChange={handleConnectorID} required >
                <option>Select Option</option>
      {connectorListing?.map((user) => (
    <option 
      key={user?._id} 
      value={user?._id} 
      connectorId={user?.connectorId}
    
    >
      {user?.title}
    </option>
  ))}
                  </select>
              </div>
            </>
          )}
            {modalContent === 'RemoteStartTransaction' && (
            <>
             <div className="form-group">
                <label>ID Tag</label>
                <input type="text" className="form-control"  onChange={handleIDTagChange} required />
              </div>
              <div className="form-group">
                <label>Connector ID</label>
                <select className="form-control"  onChange={handleConnectorID} required >
                <option>Select Option</option>
      {connectorListing?.map((user) => (
    <option 
      key={user?._id} 
      value={user?._id} 
      connectorId={user?.connectorId}
    
    >
      {user?.title}
    </option>
  ))}
                  </select>
              </div>
            </>
          )}
             {modalContent === 'RemoteStopTransaction' && (
            <>
              
              <div className="form-group">
                <label>Transaction ID</label>
                <input type="number" className="form-control" value={transactionID} onChange={handleTransactionIDChange} required />
              </div>
            </>
          )}
             {modalContent === 'Reset' && (
            <>
              
              <div className="form-group">
              <label>Message</label>
                <select className="form-control" onChange={handleMessageChange} id="input1">
      <option value="0">Select Message</option>
      <option value="Hard">Hard</option>
      <option value="Soft">Soft</option>
     
    </select> 
              </div>
            </>
          )}
          <button type="submit" className="btn btn-primary" style={{marginRight: '10px'}}>Submit</button>
          <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
        </form>
      </Modal>

      <Modal
          isOpen={transactionmodalIsOpen}
          onRequestClose={closeAmountModal}
          contentLabel="Perform Action Modal"
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
            },
          }}
        >
          <h2>Enter Details</h2>    <h6>Wallet Amount({walletAmount})</h6>
          <form style={{ maxWidth: '500px', margin: 'auto' }}>
  <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    <label htmlFor="input2" style={{ marginRight: '10px', width: '140px' }}>Select User</label>
    <Select
      value={UserOptons.find((option) => option.value === selectedUserID) || null}
      onChange={handleUserid}
      options={UserOptons}
      placeholder="Select User"
      isClearable
      styles={{
        control: (base) => ({
          ...base,
          height: '38px',
          minWidth: '300px', // Set minimum width
          maxWidth: '300px', // Set maximum width
          boxShadow: 'none',
        }),
      }}
    />
  </div>

  <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    <label htmlFor="input1" style={{ marginRight: '10px', width: '140px' }}>Connector ID</label>
    <select 
      className="form-control"
      id="input1"
      onChange={handleConnectorID}
      style={{ flex: 1, maxWidth: '300px' }} // Prevents the select from expanding too wide
    >
      <option>Select Option</option>
      {connectorListing?.map((user) => (
        <option 
          key={user?._id} 
          value={user?._id} 
        >
          {user?.title}
        </option>
      ))}
    </select>
  </div>

  <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    <label htmlFor="input2" style={{ marginRight: '10px', width: '140px' }}>Request Amount</label>
    <input
      type="text"
      className="form-control"
      id="input2"
      onChange={handleAmount}
      placeholder="Enter requested Amount"
      style={{ flex: 1, maxWidth: '300px' }} // Keeps input constrained
    />
  </div>

  <div className="form-group" style={{ textAlign: 'center' }}>
    <button type="button" className="btn btn-primary" onClick={handleAmountSubmit} style={{ marginRight: '10px' }}>
      Request for Charging
    </button>
    <button type="button" className="btn btn-secondary" onClick={closeAmountModal}>
      Close
    </button>
  </div>
</form>
</Modal>
    </div>
  );
};

export default OcppLogs;